import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['begesSecondaryStandardWrapper', 'ghgSecondaryStandardWrapper']

  connect() {
    this.toggleStandardWrapperVisibility()
  }

  toggleSecondaryStandardInput() {
    this.clearSecondaryStandard()

    this.toggleStandardWrapperVisibility()
  }

  toggleStandardWrapperVisibility() {
    const referenceStandardInput = this.element.querySelector("input[name='report[reference_standard]']:checked")
    const referenceStandardValue = referenceStandardInput ? referenceStandardInput.value : null

    if (referenceStandardValue === 'ghg') {
      this.begesSecondaryStandardWrapperTarget.classList.remove('hidden')
    } else if (referenceStandardValue === 'beges_v5') {
      this.ghgSecondaryStandardWrapperTarget.classList.remove('hidden')
    }
  }

  clearSecondaryStandard() {
    this.begesSecondaryStandardWrapperTarget.classList.add('hidden')
    this.ghgSecondaryStandardWrapperTarget.classList.add('hidden')

    this.uncheckSecondaryToggle('report[beges_secondary_standard]')
    this.uncheckSecondaryToggle('report[ghg_secondary_standard]')
  }

  uncheckSecondaryToggle(toggleName) {
    const toggleInput = this.element.querySelector(`input[name='${toggleName}'][type='checkbox']`)
    if (toggleInput) {
      toggleInput.checked = false
    }
  }
}
